module.exports = __webpack_public_path__ + "assets/img/icon1.5bcf14de.svg";